/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_External8Inputs */

const cs_role_external8 = /** @type {(inputs: Role_External8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externí`)
};

const en_role_external8 = /** @type {(inputs: Role_External8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External`)
};

/**
* | output |
* | --- |
* | "External" |
*
* @param {Role_External8Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
const role_external8 = /** @type {((inputs?: Role_External8Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_External8Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_external8(inputs)
	return cs_role_external8(inputs)
});
export { role_external8 as "role_EXTERNAL" }